/**
 * Pushes an event to Crisp data layer.
 * @param name
 */
export function pushSingleCrispEvent(name) {
  if (window.$crisp) {
    window.$crisp.push(['set', 'session:event', [name]]);
  }
}

/**
 * Pushes an event to Crisp data layer.
 * @param names
 */
export function pushMultipleCrispEvents(names) {
  if (window.$crisp) {
    window.$crisp.push(['set', 'session:event', names]);
  }
}

/**
 * Pushes a variable to Crisp session data layer.
 * @param name
 * @param value
 */
export function pushSingleCrispSessionParam(name, value) {
  if (window.$crisp) {
    window.$crisp.push([
      'set', 'session:data', [
        [
          [name, value],
        ],
      ],
    ]);
  }
}

/**
* Pushes a variable to Crisp session data layer.
* @param data
*/
export function pushMultipleCrispSessionParam(data) {
  if (window.$crisp) {
    window.$crisp.push([
      'set', 'session:data', [
        data,
      ],
    ]);
  }
}

/**
 * Opens Crisp chat.
 */
export function openCrispChat() {
  if (window.$crisp) {
    window.$crisp.push(['do', 'chat:open']);
  }
}

/**
 * Send message to crisp chat
 */
export function sendMessageToCrispChat(message) {
  if (window.$crisp) {
    window.$crisp.push(['set', 'message:text', [message]]);
    window.$crisp.push(['do', 'chat:open']);
  }
}

/**
 * Hide Crisp chat.
 */
export function hideCrispChat() {
  if (window.$crisp) {
    window.$crisp.push(['do', 'chat:hide']);
  }
}

/**
 * Refresh Crisp chat.
 */
export function refreshCrispChat(token = null) {
  if (window.$crisp) {
    if (token) {
      window.CRISP_TOKEN_ID = token;
    }

    window.$crisp.push(['do', 'session:reset']);
    window.$crisp.push(['safe', true]);
  }
}

export function clearCrispSession() {
  if (window.$crisp) {
    window.$crisp.push(['do', 'session:reset']);
  }
}
